import { useId, type ReactNode } from 'react';
import { DETAIL_LABEL_CLASS, DETAIL_SPAN_CLASS } from './detailFieldLayout';

interface DetailSlotProps {
    label: string;
    span: number;
    children: ReactNode;
}

// A labelled field-grid cell for read-only content: nothing is editable, so no EDITED or empty marker.
export function DetailSlot({ label, span, children }: DetailSlotProps) {
    const labelId = useId();
    return (
        <div
            role="group"
            aria-labelledby={labelId}
            className={`flex flex-col gap-1.5 min-w-0 ${DETAIL_SPAN_CLASS[span] ?? ''}`}
        >
            <span id={labelId} className={DETAIL_LABEL_CLASS}>
                {label}
            </span>
            {children}
        </div>
    );
}
